
import React, { useState } from "react";

//import { jsPDF } from "jspdf";

import JSZip from "jszip";
import { saveAs } from 'file-saver';

import { useDropzone } from "react-dropzone"

import "./ImgToPdf.css"

export default function ImgToPdf(props) {

    const [files, setFiles] = useState([]);

    const UNIT_INCH = "in";
    const UNIT_MM = "mm";
    const UNIT_CM = "cm";
    const UNIT_PT = "pt";
    const UNIT_PX = "px";

    const UNITS_PER_INCH = {
        "in": 1,
        "mm": 25.4,
        "cm": 2.54,
        "pt": 72,
    };

    const FORMAT_SOURCE = "source-size";
    const FORMAT_CUSTOM = "custom-size";
    const [outputFormat, setOutputFormat] = useState(FORMAT_SOURCE);

    const [outputUnit, setOutputUnit] = useState(UNIT_INCH);
    const [outputWidth, setOutputWidth] = useState(null);
    const [outputHeight, setOutputHeight] = useState(null);
    const [outputResolution, setOutputResolution] = useState(null);
    const [upscaleImage, setUpscaleImage] = useState(false);

    const QUAL_MAX_RES = "max-resolution";
    const QUAL_MAX_UNIF = "max-uniformity";
    const [outputQual, setOutputQual] = useState(QUAL_MAX_RES);

    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({
        accept: props.accept,
        onDrop: (accepted) => {
            const newFiles = accepted.map((f) =>
                Object.assign(
                    f, { preview: URL.createObjectURL(f) }
                )
            );
            const fileQueue = [
                ...files,
                ...newFiles
            ];
            //console.log(fileQueue);
            setFiles(fileQueue);
        }
    });

    const handleDelete = (file, index) => {
        const remaining = [...files]
        remaining.splice(index, 1);
        if (file.preview) {
            URL.revokeObjectURL(file.preview);
        }
        setFiles(remaining)
    };

    const deleteAll = () => {
        for (var i = 0; i < files.length; i++) {
            if (files[i].preview) {
                URL.revokeObjectURL(files[i].preview);
            }
        }
        setFiles([])
    };

    const getThumbs = () => {
        const thumbs = files.map(
            (file, index) =>
                <div className="thumbnail-container" key={index}>
                    <button
                        className="delete-file"
                        onClick={() => handleDelete(file, index)}
                    >
                        <img width="24px" height="24px" src="/ui/xv2-32px.png" alt="Remove File from List"></img>
                    </button>
                    <div className="thumbnail-outline">
                        <img className="thumbnail" src={file.preview} alt={file.name} ></img>
                        <p className="thumbnail-name">{file.name}</p>
                    </div>
                    <button
                        className="download-file"
                        onClick={() => downloadPDF(file, index)}
                    >
                        <img width="68px" height="20px" src="/ui/pdfdlv2-32px.png" alt="Download File as PDF"></img>
                    </button>
                </div>
        );

        if (thumbs.length > 0) {
            const clearAll = (
                <div className="thumbnail-container" key="-1" >
                    <button
                        className="delete-all-files"
                        onClick={() => deleteAll()}
                    >
                        <div className="thumbnail-outline" >
                            <img className="thumbnail" src="/ui/clear-all-black-256px.png" alt="Clear All" ></img>

                        </div>
                    </button> 
                </div >
            );

            return [clearAll, ...thumbs];
        }

        return (<p>Previews of selected images will appear here.</p>);
    };


    const addImageToPDF = async (imgFile, index, pdfDoc, callback) => {
        const reader = new FileReader();
        var done = false;
        reader.addEventListener("load", () => {
            const afterLoad = (width, height) => {
                //console.log(width, height);

                // FORMAT_SOURCE by default
                var format = [width, height];
                var orientation = width <= height ? "p" : "l";

                var imgX = 0;
                var imgY = 0;
                var imgWidth = width;
                var imgHeight = height;

                if (outputFormat === FORMAT_CUSTOM) {
                    if (outputWidth !== null || outputHeight !== null) {

                        var pageWidth, pageHeight;

                        // ONE OR MORE, AT LEAST ONE
                        if (outputWidth !== null) {
                            pageWidth = outputWidth * (outputResolution ?? 72);
                        }
                        if (outputHeight !== null) {
                            pageHeight = outputHeight * (outputResolution ?? 72);
                        }

                        // ONE OR NONE ONLY, NOT BOTH
                        if (outputWidth === null) {
                            pageWidth = pageHeight * (imgWidth / imgHeight);

                            if (!upscaleImage && imgWidth < pageWidth) {
                                pageWidth = imgWidth;
                            }
                        }
                        if (outputHeight === null) {
                            pageHeight = pageWidth * (imgHeight / imgWidth);

                            if (!upscaleImage && imgHeight < pageHeight) {
                                pageHeight = imgHeight;
                            }
                        }

                        //console.log(pageWidth, pageHeight);

                        // restrict imgWidth, imgHeight to a maximum of pageWidth, pageHeight
                        // while maintaining the image aspect ratio
                        if (imgWidth > pageWidth) {
                            imgHeight = imgHeight * (pageWidth / imgWidth);
                            imgWidth = pageWidth;   
                        }
                        if (imgHeight > pageHeight) {
                            imgWidth = imgWidth * (pageHeight / imgHeight);
                            imgHeight = pageHeight;
                        }

                        if (upscaleImage) {
                            if (imgWidth / imgHeight >= pageWidth / pageHeight) {

                                if (imgWidth < pageWidth) {
                                    imgHeight = imgHeight * (pageWidth / imgWidth);
                                    imgWidth = pageWidth;
                                }
                            }
                            else {
                                if (imgHeight < pageHeight) {
                                    imgWidth = imgWidth * (pageHeight / imgHeight);
                                    imgHeight = pageHeight;
                                }
                            }
                        }

                        //console.log(imgWidth, imgHeight);

                        // center the image on the page
                        if (imgWidth < pageWidth) {
                            imgX = (pageWidth - imgWidth) / 2;
                        }
                        if (imgHeight < pageHeight) {
                            imgY = (pageHeight - imgHeight) / 2;
                        }

                        format = [pageWidth, pageHeight];
                        orientation = pageWidth <= pageHeight ? "p" : "l";

                    }
                    // double null is equivalent to FORMAT_SOURCE
                }

                pdfDoc.addPage(format, orientation);
                pdfDoc.addImage(reader.result, "JPEG", imgX, imgY, imgWidth, imgHeight);
                callback(index);
            }

            const image = new Image();
            image.onload = () => {
                const width = image.naturalWidth;
                const height = image.naturalHeight;

                afterLoad(width, height);
                done = true;
            }
            image.src = reader.result;
        });
        reader.readAsDataURL(imgFile);

        while (!done) {
            //console.log("Not done", index);
            await new Promise(r => setTimeout(r, 25));
        }
    }

    const getBasePDF = (jsPDF) => {
        const ppi = (outputResolution ?? 72) * UNITS_PER_INCH[outputUnit];
        //console.log(UNITS_PER_INCH, outputUnit);
        //console.log(ppi);
        const doc = jsPDF({ unit: "px", userUnit: 72/ppi, putOnlyUsedFonts: true, /*compress: true*/ });
        //doc.__private__.setPdfVersion("1.4")
        doc.deletePage(1);
        return doc;
    }

    const downloadPDF = (file, index) => {
        import("jspdf").then(({ jsPDF }) => {
            const doc = getBasePDF(jsPDF);

            addImageToPDF(file, index, doc,
                (i) => {
                    doc.save((i + 1) + "-" + file.name + " [img2pdf.com].pdf");
                }
            );
        });
    };

    const downloadCombinedPDF = async () => {
        await import("jspdf").then(async ({ jsPDF }) => {
            const doc = getBasePDF(jsPDF);

            for (var i = 0; i < files.length; i++) {
                await addImageToPDF(files[i], i, doc,
                    (index) => {
                        if (index === files.length - 1) {
                            doc.save("Combined [img2pdf.com].pdf");
                        }
                    }
                );
            }
        });
    };

    const downloadZIP = async () => {
        const zip = new JSZip();

        await import("jspdf").then(async ({ jsPDF }) => {
            for (var i = 0; i < files.length; i++) {
                const doc = getBasePDF(jsPDF);

                await addImageToPDF(files[i], i, doc,
                    (index) => {
                        const buf = doc.output("arraybuffer");
                        zip.file((index+1) + "-" + files[index].name + ".pdf", buf);

                        if (index === files.length - 1) {
                            zip.generateAsync({ type: "blob" })
                                .then((blob) => {
                                    saveAs(blob, "All [img2pdf.com].zip");
                                });
                        }
                    }
                );
            }
        });
    }

    const updateSettings = (event) => {
        const settingName = event.target.name.trim()
        const settingValue = event.target.value.trim();

        //console.log(settingName, settingValue);

        //console.log(event.target);
        if (!event.target.validity.valid) {
            console.log("Invalid input");
            return;
        }

        switch (settingName) {

            case "output-quality":
                if (event.target.checked) {
                    setOutputQual(settingValue);
                }
                break;

            case "output-format":
                if (event.target.checked) {
                    setOutputFormat(settingValue);
                }
                break;

            case "width-input":
                if (settingValue === "") {
                    setOutputWidth(null);
                }
                else {
                    setOutputWidth(parseFloat(settingValue));
                }
                break;

            case "height-input":
                if (settingValue === "") {
                    setOutputHeight(null);
                }
                else {
                    setOutputHeight(parseFloat(settingValue));
                }
                break;

            case "resolution-input":
                if (settingValue === "") {
                    setOutputResolution(null);
                }
                else {
                    setOutputResolution(parseFloat(settingValue));
                }
                break;
                

            case "unit-select":
                setOutputUnit(settingValue);
                break;

            case "upscale-image":
                if (event.target.checked) {
                    setUpscaleImage(true);
                }
                else {
                    setUpscaleImage(false);
                }
                break;

            default:
                break;

        }
    };

    return (

        <div className="container p-0 m-0">

            <div {...getRootProps({ className: "file-upload" })} style={{height: props.height, color: props.color, backgroundColor: props.bgColor}}>
                <label>
                    <p className="display-text">Drop or Upload Files Here</p>
                    <input {...getInputProps()}></input>
                </label>
            </div>
            <div className="file-options">
                <button
                    className="bulk-download" id="combined"
                    onClick={downloadCombinedPDF}
                >
                    Download Combined PDF
                    
                </button>
                {/*<button
                    className="bulk-download" id="output-format"
                    onClick={() => { setOutputFormat(outputFormatOptions[(outputFormat.state + 1) % outputFormatOptions.length]); console.log(outputFormat); }}
                >
                    Format: {outputFormat.text}
                </button>*/}
                <button
                    className="bulk-download" id="as-zip"
                    onClick={downloadZIP}
                >
                    Download All as ZIP
                </button>
                
            </div>
            <div className="thumbnail-gallery">
                {getThumbs()}
            </div>
            <hr style={{ color: "lightgray" }} />

            {/*
            <div id="feedback">
                <form>
                    <span>
                        Please rate this tool:
                    </span>
                    <span><input type="radio" name="rating" id="str5" value="5"/><label for="str5"></label></span>
                    <span><input type="radio" name="rating" id="str4" value="4"/><label for="str4"></label></span>
                    <span><input type="radio" name="rating" id="str3" value="3"/><label for="str3"></label></span>
                    <span><input type="radio" name="rating" id="str2" value="2"/><label for="str2"></label></span>
                    <span><input type="radio" name="rating" id="str1" value="1" /><label for="str1"></label></span>
                    <div>
                        Comments:
                        <input type="textbox"></input>
                    </div>
                    <button>
                    Submit
                    </button>
                  
                </form>

            </div>

            <hr style={{ color: "lightgray" }} />
            */}

            {/*<a href="#show-settings" id="show-settings">
                <h2>
                    <img width="24px" height="24px" src="/ui/expandv2-64px.png" alt="Expand"/>
                    &thinsp;
                    Img2pdf Settings
                </h2>
                
            </a>
            <a href="#hide-settings" id="hide-settings">
                <h2>
                    <img width="24px" height="24px" src="/ui/collapsev2-64px.png" alt="Collapse"/>
                    &thinsp;
                    Img2pdf Settings
                </h2>
            </a>*/}
            <h2>
                Img2pdf Settings
            </h2>
            
            <div id="settings">
                <p>
                    By default each PDF will have the same dimensions as the input image and a resolution of 72 pixels per inch. This is suitable for most applications.
                </p>
                <form name="settingsForm" id="settingsForm"
                    onChange={updateSettings}
                >      
                    {/*<fieldset>
                        <legend><h3 className="settings-text">Output Quality</h3></legend>
                        <p className="settings-text">
                            <div className="row">
                                <div className="col-auto">
                                        <input type="radio" id="output-quality-max" name="output-quality" value={QUAL_MAX_RES} onClick={updateSettings} checked />
                                </div>
                                <div className="col-10">
                                    <label htmlFor="output-quality-max">Maximize Image Quality: Retain the original image pixel dimensions in the output file.</label>
                                </div>
                            </div>
                        </p>
                        <p className="settings-text">
                            <div className="row">
                                <div className="col-auto">
                                    <label>
                                        <input type="radio" id="output-quality-uniform" name="output-quality" value={QUAL_MAX_UNIF} onClick={updateSettings}/>
                                    </label>
                                </div>
                                <div className="col-10">
                                    <label htmlFor="output-quality-uniform">Prefer Uniform Output: Resize the image pixel dimensions to fit within the selected output format.</label>
                                </div>
                            </div>
                        
                        </p>
                    </fieldset>*/}
                    <fieldset>
                        <legend><h3 className="settings-text">Document Setup</h3></legend>

                        <div className="row settings-text">
                            <div className="col">
                                <label htmlFor="unit-select">Document Units:</label>
                                &nbsp;
                                <select id="unit-select" name="unit-select" className="settings-input" >
                                    <option value={UNIT_INCH}>inches (in)</option>
                                    <option value={UNIT_CM}>centimeters (cm)</option>
                                    <option value={UNIT_MM}>millimeters (mm)</option>
                                    <option value={UNIT_PT}>points (pt)</option>
                                </select>
                            </div>
                        </div>
                        <div className="row settings-text">
                            <div className="col">
                                <label htmlFor="resolution-input">Resolution:</label>
                                &nbsp;
                                <input id="resolution-input" name="resolution-input" className="settings-input" type="text" placeholder="72" pattern="^(\d+)?(\.\d*)?\s*$" />

                                &nbsp;px&nbsp;/&nbsp;

                                <output htmlFor="unit-select">{outputUnit}</output>

                                &nbsp;&nbsp;
                                {
                                    (() => {
                                        var result = "";

                                        const ppi = Math.round((outputResolution ?? 72) * UNITS_PER_INCH[outputUnit]);
                                        result += ppi + " ppi";

                                        result += "; "

                                        if (ppi < 72) {
                                            result += "Poor";
                                        }
                                        else if (ppi >= 72 && ppi < 144) {
                                            result += "Web";
                                        }
                                        else if (ppi >= 144 && ppi < 200) {
                                            result += "Average";
                                        }
                                        else if (ppi >= 200 && ppi < 288) {
                                            result += "Medium"
                                        }
                                        else if (ppi >= 288 && ppi < 300) {
                                            result += "High";
                                        }
                                        else if( ppi >= 300 && ppi < 576) {
                                            result += "Print";
                                        }
                                        else {
                                            result += "Extreme";
                                        }

                                        return "(" + result + ")";
                                    })()
                                }
                            
                            </div>
                        </div>
                        {/*<table>
                            <caption>
                                <h4>Common Document Resolutions</h4>
                            </caption>
                            <thead>
                                <tr>
                                    <th scope="col" colSpan="1"></th>
                                    <th scope="col" colSpan="1">Poor</th>
                                    <th scope="col" colSpan="3">Web</th>
                                    <th scope="col" colSpan="2">Average</th>
                                    <th scope="col" colSpan="3">Medium</th>
                                    <th scope="col" colSpan="1">High</th>
                                    <th scope="col" colSpan="2">Print</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">px / in</th>
                                    <td>36.0</td>
                                    <td>72.0</td>
                                    <td>96.0</td>
                                    <td>100</td>
                                    <td>144</td>
                                    <td>150</td>
                                    <td>200</td>
                                    <td>216</td>
                                    <td>250</td>
                                    <td>288</td>
                                    <td>300</td>
                                    <td>360</td>
                                </tr>
                                <tr>
                                    <th scope="row">px / cm</th>
                                    <td>14.2</td>
                                    <td>28.3</td>
                                    <td>37.8</td>
                                    <td>39.4</td>
                                    <td>56.7</td>
                                    <td>59.1</td>
                                    <td>78.7</td>
                                    <td>85.0</td>
                                    <td>98.4</td>
                                    <td>113</td>
                                    <td>118</td>
                                    <td>142</td>
                                </tr>
                                <tr>
                                    <th scope="row">px / mm</th>
                                    <td>1.42</td>
                                    <td>2.83</td>
                                    <td>3.78</td>
                                    <td>3.94</td>
                                    <td>5.67</td>
                                    <td>5.91</td>
                                    <td>7.87</td>
                                    <td>8.50</td>
                                    <td>9.84</td>
                                    <td>11.3</td>
                                    <td>11.8</td>
                                    <td>14.2</td>
                                </tr>
                                <tr>
                                    <th scope="row">px / pt</th>
                                    <td>0.50</td>
                                    <td>1.00</td>
                                    <td>1.33</td>
                                    <td>1.39</td>
                                    <td>2.00</td>
                                    <td>2.08</td>
                                    <td>2.78</td>
                                    <td>3.00</td>
                                    <td>3.47</td>
                                    <td>4.00</td>
                                    <td>4.17</td>
                                    <td>5.00</td>
                                </tr>
                            </tbody>
                        </table>*/}
                    </fieldset>
                    <fieldset>
                        <legend>
                            <h3 className="settings-text">Output Format</h3>
                        </legend>
                        <div className="row settings-text">
                            <div className="col-auto">
                                <input id="output-format-source" name="output-format" type="radio" value={FORMAT_SOURCE} onClick={updateSettings} defaultChecked />
                            </div>
                            <div className="col-10">
                                <label htmlFor="output-format-source">Use the source image to determine the PDF page size.</label>
                            </div>
                        </div>
                        <div className="row settings-text">
                            <div className="col-auto">
                                <input id="output-format-custom" name="output-format" type="radio" value={FORMAT_CUSTOM} onClick={updateSettings} />
                            </div>
                            <div className="col-10">
                                <label htmlFor="output-format-custom">Set the PDF page size using manual overrides.</label>

                                <br style={{ marginBottom: "1rem" }} />

                                <label htmlFor="width-input">W:&nbsp;</label>
                                <input id="width-input" name="width-input" className="settings-input" type="text" pattern="^(\d+)?(\.\d*)?\s*$" />
                                <output htmlFor="unit-select">&nbsp;{outputUnit}</output>

                                &nbsp;&nbsp;&times;&nbsp;&nbsp;

                                <label htmlFor="height-input">H:&nbsp;</label>
                                <input id="height-input" name="height-input" className="settings-input" type="text" pattern="^(\d+)?(\.\d*)?\s*$" />
                                <output htmlFor="unit-select">&nbsp;{outputUnit}</output>
                                <output htmlFor="width-input height-input">
                                    {
                                        (() => {
                                            var result = "";

                                            //console.log(outputWidth, outputHeight);

                                            if (outputWidth !== null && outputHeight !== null) {
                                                // (space)(nbsp)(=>)(nbsp)(nbsp)Orienation:(nbsp)
                                                result = " \u00a0\u21d2\u00a0\u00a0Orientation:\u00a0";

                                                if (outputWidth > outputHeight) {
                                                    result += "Landscape";
                                                }
                                                else if (outputWidth < outputHeight) {
                                                    result += "Portrait";
                                                }
                                                else {
                                                    result += "Square";
                                                }
                                            }
                                            else if (outputWidth !== null) {
                                                result += " \u00a0\u21d2\u00a0\u00a0Fixed width; Height determined by image";
                                            }
                                            else if (outputHeight !== null) {
                                                result += " \u00a0\u21d2\u00a0\u00a0Fixed height; Width determined by image";
                                            }
                                            return result;
                                        })()
                                    }
                                </output>
                                <br style={{ marginBottom: "1rem" }} />
                                <input id="upscale-image" name="upscale-image" type="checkbox" value="upscale-image" onClick={updateSettings} />
                                &nbsp;
                                <label htmlFor="upscale-image">Upscale image to fit page? May cause pixelation in low-quality images.</label>
                            </div>
                        </div>
                    
                    </fieldset>
                </form>
                <h3>Tips</h3>
                <p>
                    <strong>Document Units:</strong> If you change the document units to anything other than inches, it is strongly recommended to also update the resolution since it will retain the default value (72) regardless of unit.
                </p>
                <p>
                    <strong>Resolution:</strong> The default resolution is 72 pixels per unit. If you change the resolution, the output on the right will give the equivalent resolution in pixels per inch (ppi) and the quality level of said resolution (Poor, Web, Avg., Med., High, Print, Extreme).
                </p>
                <p>
                    <strong>Manual Overrides:</strong> Setting only one of the W or H fields will allow the other to vary in accordance with the size of the image.
                </p>
                {/*<p>
                    Note: If you change the unit from the default (inches), you must also set the resolution. Otherwise the output PDF will
                </p>

                <h3>US Paper Sizes</h3>
                <ul>
                    <li>Letter (8.5 in &times; 11 in)</li>
                    <li>Legal (8.5 in &times; 14 in)</li>
                    <li>Tabloid (11 in &times; 17 in)</li>
                </ul>
                <h3>ISO Paper Sizes</h3>
                <ul>
                    <li>A3 (29.7 cm &times; 42.0 cm)</li>
                    <li>A4 (21.0 cm &times; 29.7 cm)</li>
                    <li>A5 (14.8 cm &times; 21.0 cm)</li>
                </ul>*/}
            </div>
            <hr style={{ color: "lightgray" }} />

            {/*<a href="#show-faq" id="show-faq">
                <h2>
                    <img width="24px" height="24px" src="/ui/expandv2-64px.png" alt="Expand"/>
                    &thinsp;
                    FAQ: Img2pdf Converter
                </h2>

            </a>
            <a href="#hide-faq" id="hide-faq">
                <h2>
                    <img width="24px" height="24px" src="/ui/collapsev2-64px.png" alt="Collapse"/>
                    &thinsp;
                    FAQ: Img2pdf Converter
                </h2>
            </a>*/}   
        </div>
    );
}